import { nanoid } from 'nanoid';

export function generateTempId() {
  return `temp-${nanoid()}`;
}

export function isTempId(id) {
  return typeof id === 'string' && id.startsWith('temp-');
}

export function cleanEntityIds(entityList) {
  return entityList.map((entity) => {
    const cleaned = { ...entity };
    if (isTempId(cleaned.id)) {
      delete cleaned.id;
    }
    return cleaned;
  });
}
